export default "__VITE_ASSET__CTH3opkt__"